<template>
    <div class="zebra-crossing-detail">
        <!--  解决方案 -->
        <el-form>
            <div class="zebra-item">
                <div class="card-line-header"  >
                    <router-link :to="{ path:'/addKnowledge',query: { parentNumber:serialNumber ,callback:getDetail} }">
                        <el-button type="primary" v-if="detail.knowledgeSubmission">提交为知识</el-button>
                    </router-link>
                    <span class="ml10">提交到对应的知识库</span>
                </div>
                <el-row v-if="showSolutionForm">
                    <el-col :span="12">
                        <el-form-item label="解决方式：">{{ detail.solutionMode | tableVal(solutionMode) }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="原因：">{{ detail.reason  | tableVal(solutionReason)}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="解决标识：">{{ detail.solutionLabel | tableVal(solutionLabel) }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="解决方案：">
                            <span v-html="detail.solutionComment"></span>
                        </el-form-item>
                    </el-col>
                </el-row>

            </div>
        </el-form>
    </div>
</template>

<script>
    export default {
        props:{
            detail:Object,
            serialNumber:String,
            callback:Function,
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            //解决方式
            solutionMode(){
                return this.dictionary.solution_mode;
            },
            //原因
            solutionReason(){
                return this.dictionary.solution_reason;
            },
            //解决标识
            solutionLabel(){
                return this.dictionary.solution_label;
            },

        },
        data() {
            return {
                showSolutionForm:false,//解决方式和原因隐藏
            }
        },
        created() {
            this.hideSolutionForm()
        },
        methods: {
            getDetail(){
                this.callback()
            },
            hideSolutionForm(){
                let sn=this.serialNumber
              if(sn.indexOf('Eve')>-1){
                  this.showSolutionForm=true
              }
            },

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
